export default __webpack_public_path__ + "static/media/cookie4.8cbcca58.svg";